import * as React from 'react';
import { SVGProps } from 'react';

const IconFileMailSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 3h14v10H1V3Zm1.847 1L6.79 7.393 8 8.36l1.21-.967L13.153 4H2.847ZM14 4.59l-3.725 3.207L14 11.335V4.59ZM13.248 12 9.5 8.44 8 9.64l-1.501-1.2L2.752 12h10.496ZM2 11.335V4.59l3.725 3.207L2 11.335Z"
    />
  </svg>
);
export default IconFileMailSizeS;
